module.exports = __webpack_public_path__ + "static/face-filter-ac4dc0f36a7b462cc727accc388aa53a.jpg";